import React, { useState, useEffect } from "react";
import { func, bool, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { parseUrl } from "query-string";

import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import { staticTexts } from "../../utils/Translate";
import { setLoading } from "../../helper/actions";
import NotLoggedInView from "../NotLoggedInView";

import { getBookmarkStories, getUser } from "../../helper/api";

import "./saved-story-view.m.css";

const SavedStoryView = ({
  setLoading,
  isLoading,
  jwtToken,
  metypeConfig,
  currentPath,
  sketchesHost,
  authHost,
  lang,
}) => {
  const [stories, setStories] = useState([]);
  const [member, setMember] = useState(null);
  const [isMoreStoriesAvailable, setIsMoreStoriesAvailable] = useState(true);
  const [page, setPage] = useState(1);
  const [renderComponent, setRenderComponent] = useState(false);
  const [callbackUrl, setCallbackUrl] = useState(sketchesHost);
  const [redirectUrl, setRedirectUrl] = useState(sketchesHost);

  const params = parseUrl(currentPath);

  const getRedirectUrl = (defaultRedirectUrl) => {
    const redirectUrl = get(params, ["query", "redirect-url"], defaultRedirectUrl);
    setRedirectUrl(redirectUrl);
  };

  useEffect(() => {
    setCallbackUrl(get(params, ["query", "callback-url"], global.location.origin));
    if (
      params.url.includes("sign-in-page") ||
      params.url.includes("sign-up-page") ||
      params.url.includes("forgot-password")
    ) {
      getRedirectUrl(sketchesHost);
    } else {
      params.url.includes("verify-email") ? getRedirectUrl(sketchesHost) : getRedirectUrl(global.location.href);
    }
  }, [params]);

  useEffect(() => {
    getUser().then((resp) => setMember(resp));
    jwtToken && getStories();
  }, [jwtToken]);

  const getStories = () => {
    page === 1 && setLoading(true);
    getBookmarkStories(metypeConfig, jwtToken, page)
      .then((storyList) => {
        if (storyList.length) {
          storyList.forEach((article) => {
            if (article?.["hero-image-s3-key"]) {
              // Remove query parameters added by the getImageCropUrl utility function.
              article["hero-image-s3-key"] = article["hero-image-s3-key"].split("?rect")[0];
            }
          });
          const newList = [...stories, ...storyList];
          setStories(newList);
          setPage(page + 1);
          storyList.length < 50 && setIsMoreStoriesAvailable(false);
        } else {
          setIsMoreStoriesAvailable(false);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setRenderComponent(true);
  }, []);

  return (
    <React.Fragment>
      {renderComponent && (
        <>
          {member ? (
            <div styleName="top-container">
              <div styleName="content">
                <div styleName="title-details">
                  <h3 styleName="title">{staticTexts(lang).savedPageTitle}</h3>
                  <h3 styleName="sub-title">{staticTexts(lang).savedPageSubTitle}</h3>
                </div>
              </div>

              <Stories2AdWithLoadMore
                list={stories}
                loading={isLoading}
                onLoadMore={getStories}
                isMoreStories={isMoreStoriesAvailable}
              />
            </div>
          ) : (
            <NotLoggedInView authHost={authHost} redirectUrl={redirectUrl} callbackUrl={callbackUrl} />
          )}
        </>
      )}
    </React.Fragment>
  );
};

SavedStoryView.propTypes = {
  setLoading: func,
  isLoading: bool,
  jwtToken: string,
  metypeConfig: object,
  member: object,
  currentPath: string,
  sketchesHost: string,
  authHost: string,
  lang: string,
};

const mapStateToProps = (state) => ({
  isLoading: get(state, ["pageLoading"], false),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com"),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedStoryView);
